import { EnumOptionsList } from "@/types/common";
import { OverIssueReasonTypeEnum } from "@/types/reimburse";
import { useTranslation } from "react-i18next";

const useOverIssueReasonTypeEnum = () => {
  const { t } = useTranslation();
  const OverIssueReasonTypeEnumList: EnumOptionsList<OverIssueReasonTypeEnum>[] = [
    {
      key: OverIssueReasonTypeEnum.MISTAKE,
      value: OverIssueReasonTypeEnum.MISTAKE,
      color: "red",
      label: t("reimburse.reasonMistake")
    },
    {
      key: OverIssueReasonTypeEnum.WASTE,
      value: OverIssueReasonTypeEnum.WASTE,
      color: "orange",
      label: t("reimburse.reasonWaste")
    },
    {
      key: OverIssueReasonTypeEnum.OTHER,
      value: OverIssueReasonTypeEnum.OTHER,
      color: "geekblue",
      label: t("reimburse.reasonOther")
    },
  ];

  const getOverIssueReasonTypeEnum = (val: OverIssueReasonTypeEnum | null) => {
    if (val === null) return
    return OverIssueReasonTypeEnumList.find(i => i.value === val);
  };

  return {
    OverIssueReasonTypeEnumList,
    getOverIssueReasonTypeEnum
  }
};

export default useOverIssueReasonTypeEnum;
